import { Toast } from '@globalmed/atlas-ui';
import styles from './ToastController.module.css';
import { useToastStore } from '@/stores/toast';

/**
 * ToastController component responsible for rendering all active toasts.
 * Features:
 * - Retrieves the current list of toasts from the toast store.
 * - Renders each toast using the `Toast` component from `@globalmed/atlas-ui`.
 * - Handles click events on individual toasts (currently logs the click info to console).
 * Usage:
 * Include this component at a high level in your app (e.g., in the main layout)
 * so that all toasts can be displayed globally.
 * @returns JSX.Element representing a container of toast notifications.
 */
export const ToastController = () => {
  const { toasts } = useToastStore();

  const handleToastClick = (id: string, str: string) => {
    // eslint-disable-next-line no-console
    console.log({ id, str });
  };

  return (
    <div
      className={styles.container}
      role="status"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map(({ id, body }) => (
        <Toast
          key={id}
          {...body}
          onClick={(str) => handleToastClick(id, str)}
        />
      ))}
    </div>
  );
};
